export interface ComicChapter {
  id: number;
  title: string;
  updateDate: string;
}

export interface Comic {
  id: number;
  slug: string;
  title: string;
  author: string;
  cover: string;
  description: string;
  categories: string[];
  rating: number;
  views: number;
  status: '连载中' | '已完结';
  lastUpdated: string;
  chapters: ComicChapter[];
  featured: boolean;
  hot: boolean;
}

export const categories = [
  { slug: 'all', name: '全部' },
  { slug: 'romance', name: '恋爱' },
  { slug: 'fantasy', name: '奇幻' },
  { slug: 'action', name: '动作' },
  { slug: 'comedy', name: '搞笑' },
  { slug: 'thriller', name: '悬疑' },
  { slug: 'drama', name: '剧情' },
  { slug: 'daily', name: '日常' },
  { slug: 'historical', name: '古风' },
  { slug: 'horror', name: '恐怖' },
];

export const comics: Comic[] = [
  {
    id: 1,
    slug: 'queen-of-shadows',
    title: '影后重生',
    author: '李智恩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cover%20art%2C%20elegant%20woman%20in%20black%20dress%20with%20dramatic%20lighting%2C%20dark%20moody%20atmosphere%2C%20professional%20digital%20illustration%2C%20soft%20gradient%20background%2C%20clean%20composition&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '曾是影后的她，意外重生回到十年前。面对昔日背叛与阴谋，她决定这一次不再忍让，要用实力夺回属于自己的一切。在复仇与成长的道路上，她遇到了意想不到的爱情。',
    categories: ['romance', 'drama'],
    rating: 9.4,
    views: 1280000,
    status: '连载中',
    lastUpdated: '2026-08-04',
    featured: true,
    hot: true,
    chapters: [
      { id: 1, title: '第1话 重生', updateDate: '2026-01-15' },
      { id: 2, title: '第2话 新的开始', updateDate: '2026-01-22' },
      { id: 3, title: '第3话 旧日仇人', updateDate: '2026-01-29' },
      { id: 4, title: '第4话 反击', updateDate: '2026-02-05' },
      { id: 5, title: '第5话 意外的援手', updateDate: '2026-02-12' },
      { id: 6, title: '第6话 暗流涌动', updateDate: '2026-02-19' },
      { id: 7, title: '第7话 试镜', updateDate: '2026-02-26' },
      { id: 8, title: '第8话 惊艳全场', updateDate: '2026-03-04' },
      { id: 9, title: '第9话 他的秘密', updateDate: '2026-03-11' },
      { id: 10, title: '第10话 夜幕降临', updateDate: '2026-03-18' },
      { id: 11, title: '第11话 危机逼近', updateDate: '2026-03-25' },
      { id: 12, title: '第12话 真相浮现', updateDate: '2026-04-01' },
      { id: 13, title: '第13话 选择', updateDate: '2026-04-08' },
    ],
  },
  {
    id: 2,
    slug: 'dragon-blade-legend',
    title: '龙刃传说',
    author: '金泰亨',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cover%2C%20male%20warrior%20with%20dragon%20blade%20sword%2C%20epic%20fantasy%20setting%2C%20dramatic%20composition%2C%20fire%20and%20energy%20effects%2C%20professional%20digital%20art%2C%20clean%20background&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '在一个被龙族统治的世界里，少年剑士继承了传说中的龙刃。为了拯救被囚禁的族人，他踏上了一条充满危险与荣耀的冒险之旅。',
    categories: ['fantasy', 'action'],
    rating: 9.2,
    views: 1560000,
    status: '连载中',
    lastUpdated: '2026-08-03',
    featured: true,
    hot: true,
    chapters: [
      { id: 1, title: '第1话 觉醒', updateDate: '2025-11-10' },
      { id: 2, title: '第2话 试炼', updateDate: '2025-11-17' },
      { id: 3, title: '第3话 龙刃', updateDate: '2025-11-24' },
      { id: 4, title: '第4话 启程', updateDate: '2025-12-01' },
      { id: 5, title: '第5话 暗影森林', updateDate: '2025-12-08' },
      { id: 6, title: '第6话 兽人之战', updateDate: '2025-12-15' },
      { id: 7, title: '第7话 盟友', updateDate: '2025-12-22' },
      { id: 8, title: '第8话 龙族领地', updateDate: '2025-12-29' },
      { id: 9, title: '第9话 真相', updateDate: '2026-01-05' },
      { id: 10, title: '第10话 决战前夕', updateDate: '2026-01-12' },
      { id: 11, title: '第11话 龙之怒', updateDate: '2026-01-19' },
    ],
  },
  {
    id: 3,
    slug: 'campus-sweetheart',
    title: '校园甜心',
    author: '朴秀敏',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%2C%20cute%20couple%20in%20school%20uniform%2C%20cherry%20blossom%20background%2C%20warm%20pink%20tones%2C%20youthful%20and%20fresh%20atmosphere%2C%20soft%20illustration%20style%2C%20clean%20composition&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '转学到新学校的平凡女孩，意外与校园男神成为同桌。从最初的尴尬到逐渐熟悉，一段青涩甜蜜的校园恋情悄然萌芽。',
    categories: ['romance', 'comedy', 'daily'],
    rating: 9.0,
    views: 980000,
    status: '连载中',
    lastUpdated: '2026-08-05',
    featured: false,
    hot: true,
    chapters: [
      { id: 1, title: '第1话 转学生', updateDate: '2026-04-01' },
      { id: 2, title: '第2话 同桌的你', updateDate: '2026-04-08' },
      { id: 3, title: '第3话 图书馆偶遇', updateDate: '2026-04-15' },
      { id: 4, title: '第4话 误会', updateDate: '2026-04-22' },
      { id: 5, title: '第5话 心跳加速', updateDate: '2026-04-29' },
      { id: 6, title: '第6话 他的温柔', updateDate: '2026-05-06' },
      { id: 7, title: '第7话 体育祭', updateDate: '2026-05-13' },
      { id: 8, title: '第8话 告白', updateDate: '2026-05-20' },
      { id: 9, title: '第9话 在一起', updateDate: '2026-05-27' },
    ],
  },
  {
    id: 4,
    slug: 'night-detective',
    title: '暗夜侦探',
    author: '崔在贤',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20cover%2C%20detective%20in%20dark%20alley%2C%20noir%20atmosphere%2C%20rainy%20night%20scene%2C%20mysterious%20mood%2C%20professional%20digital%20art%2C%20clean%20composition&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '首尔夜晚的连环案件，让退役刑警不得不重返调查一线。每一个线索都指向一个更大的阴谋，而真相远比想象中更加残酷。',
    categories: ['thriller', 'drama'],
    rating: 9.5,
    views: 720000,
    status: '已完结',
    lastUpdated: '2026-07-20',
    featured: true,
    hot: false,
    chapters: [
      { id: 1, title: '第1话 阴影', updateDate: '2025-06-01' },
      { id: 2, title: '第2话 第一现场', updateDate: '2025-06-08' },
      { id: 3, title: '第3话 目击者', updateDate: '2025-06-15' },
      { id: 4, title: '第4话 蛛丝马迹', updateDate: '2025-06-22' },
      { id: 5, title: '第5话 嫌疑犯', updateDate: '2025-06-29' },
      { id: 6, title: '第6话 追捕', updateDate: '2025-07-06' },
      { id: 7, title: '第7话 审讯', updateDate: '2025-07-13' },
      { id: 8, title: '第8话 反转', updateDate: '2025-07-20' },
      { id: 9, title: '第9话 真凶', updateDate: '2025-07-27' },
      { id: 10, title: '第10话 正义（终章）', updateDate: '2025-08-03' },
    ],
  },
  {
    id: 5,
    slug: 'palace-conspiracy',
    title: '宫阙谋',
    author: '尹智慧',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20historical%20manhwa%20cover%2C%20beautiful%20woman%20in%20traditional%20hanbok%20in%20palace%2C%20elegant%20and%20refined%20atmosphere%2C%20soft%20warm%20lighting%2C%20detailed%20traditional%20Korean%20architecture%2C%20clean%20composition&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '朝鲜王朝时期，一位出身卑微的女子凭借才智进入宫廷。在权力的漩涡中，她必须步步为营，在爱与生存之间做出抉择。',
    categories: ['historical', 'drama', 'romance'],
    rating: 9.3,
    views: 890000,
    status: '连载中',
    lastUpdated: '2026-08-02',
    featured: false,
    hot: true,
    chapters: [
      { id: 1, title: '第1话 入宫', updateDate: '2026-02-01' },
      { id: 2, title: '第2话 尚宫', updateDate: '2026-02-08' },
      { id: 3, title: '第3话 暗算', updateDate: '2026-02-15' },
      { id: 4, title: '第4话 同盟', updateDate: '2026-02-22' },
      { id: 5, title: '第5话 王的青睐', updateDate: '2026-03-01' },
      { id: 6, title: '第6话 阴谋', updateDate: '2026-03-08' },
      { id: 7, title: '第7话 反击的序幕', updateDate: '2026-03-15' },
    ],
  },
  {
    id: 6,
    slug: 'ghost-apartment',
    title: '幽灵公寓',
    author: '宋河琳',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20horror%20manhwa%20cover%2C%20dark%20apartment%20building%20at%20night%2C%20eerie%20atmosphere%2C%20ghostly%20figure%2C%20cold%20blue%20tones%2C%20mysterious%20and%20scary%20mood%2C%20clean%20digital%20illustration&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '搬进廉价公寓的大学生发现，每到午夜时分，走廊里总会传来奇怪的脚步声。邻居们一个个离奇失踪，而公寓管理员似乎知道些什么。',
    categories: ['horror', 'thriller'],
    rating: 8.9,
    views: 650000,
    status: '连载中',
    lastUpdated: '2026-08-01',
    featured: false,
    hot: false,
    chapters: [
      { id: 1, title: '第1话 新居', updateDate: '2026-05-01' },
      { id: 2, title: '第2话 脚步声', updateDate: '2026-05-08' },
      { id: 3, title: '第3话 302号房', updateDate: '2026-05-15' },
      { id: 4, title: '第4话 消失的邻居', updateDate: '2026-05-22' },
      { id: 5, title: '第5话 监控录像', updateDate: '2026-05-29' },
      { id: 6, title: '第6话 管理员', updateDate: '2026-06-05' },
      { id: 7, title: '第7话 地下室', updateDate: '2026-06-12' },
      { id: 8, title: '第8话 它们来了', updateDate: '2026-06-19' },
    ],
  },
  {
    id: 7,
    slug: 'chef-dream',
    title: '料理梦工厂',
    author: '韩志浩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20cover%2C%20young%20chef%20in%20kitchen%2C%20delicious%20food%20surrounding%2C%20warm%20and%20inviting%20atmosphere%2C%20bright%20colors%2C%20fun%20and%20lively%20illustration%20style%2C%20clean%20composition&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '梦想成为顶级厨师的青年，在一家面临倒闭的小餐馆开始了他的职业生涯。用真诚的料理打动每一位食客，这是一部关于梦想与美食的暖心故事。',
    categories: ['comedy', 'daily', 'drama'],
    rating: 9.1,
    views: 780000,
    status: '连载中',
    lastUpdated: '2026-08-04',
    featured: false,
    hot: true,
    chapters: [
      { id: 1, title: '第1话 梦想的起点', updateDate: '2026-03-01' },
      { id: 2, title: '第2话 第一道菜', updateDate: '2026-03-08' },
      { id: 3, title: '第3话 挑剔的客人', updateDate: '2026-03-15' },
      { id: 4, title: '第4话 秘密食谱', updateDate: '2026-03-22' },
      { id: 5, title: '第5话 料理大赛', updateDate: '2026-03-29' },
      { id: 6, title: '第6话 失败与成长', updateDate: '2026-04-05' },
      { id: 7, title: '第7话 伙伴', updateDate: '2026-04-12' },
      { id: 8, title: '第8话 重新出发', updateDate: '2026-04-19' },
      { id: 9, title: '第9话 食客的微笑', updateDate: '2026-04-26' },
    ],
  },
  {
    id: 8,
    slug: 'magic-academy',
    title: '魔法学园',
    author: '郑秀晶',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%2C%20magic%20school%20students%20casting%20spells%2C%20colorful%20magic%20effects%2C%20whimsical%20and%20enchanting%20atmosphere%2C%20vibrant%20colors%2C%20clean%20digital%20art&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '在一个魔法与科技并存的世界，普通少女意外获得魔法学院的录取通知书。在这里，她将结识各具特色的伙伴，揭开学院隐藏千年的秘密。',
    categories: ['fantasy', 'action', 'comedy'],
    rating: 9.0,
    views: 1120000,
    status: '连载中',
    lastUpdated: '2026-08-03',
    featured: true,
    hot: true,
    chapters: [
      { id: 1, title: '第1话 录取通知', updateDate: '2026-02-15' },
      { id: 2, title: '第2话 入学典礼', updateDate: '2026-02-22' },
      { id: 3, title: '第3话 第一堂课', updateDate: '2026-03-01' },
      { id: 4, title: '第4话 室友', updateDate: '2026-03-08' },
      { id: 5, title: '第5话 禁林试炼', updateDate: '2026-03-15' },
      { id: 6, title: '第6话 地下图书馆', updateDate: '2026-03-22' },
      { id: 7, title: '第7话 古老预言', updateDate: '2026-03-29' },
      { id: 8, title: '第8话 黑暗降临', updateDate: '2026-04-05' },
    ],
  },
  {
    id: 9,
    slug: 'love-contract',
    title: '契约恋人',
    author: '安孝珍',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%2C%20handsome%20CEO%20and%20ordinary%20woman%2C%20contract%20marriage%20theme%2C%20elegant%20office%20setting%2C%20sophisticated%20atmosphere%2C%20warm%20lighting%2C%20clean%20illustration&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '为了偿还家族债务，她与冷酷总裁签订了一份契约恋爱协议。原以为只是一场交易，却在朝夕相处中渐渐动了真情。',
    categories: ['romance', 'drama'],
    rating: 9.3,
    views: 1350000,
    status: '连载中',
    lastUpdated: '2026-08-05',
    featured: false,
    hot: true,
    chapters: [
      { id: 1, title: '第1话 相遇', updateDate: '2026-03-01' },
      { id: 2, title: '第2话 契约', updateDate: '2026-03-08' },
      { id: 3, title: '第3话 同居', updateDate: '2026-03-15' },
      { id: 4, title: '第4话 他的另一面', updateDate: '2026-03-22' },
      { id: 5, title: '第5话 危机', updateDate: '2026-03-29' },
      { id: 6, title: '第6话 心动', updateDate: '2026-04-05' },
      { id: 7, title: '第7话 前女友', updateDate: '2026-04-12' },
      { id: 8, title: '第8话 嫉妒', updateDate: '2026-04-19' },
      { id: 9, title: '第9话 真心', updateDate: '2026-04-26' },
      { id: 10, title: '第10话 坦白', updateDate: '2026-05-03' },
      { id: 11, title: '第11话 选择', updateDate: '2026-05-10' },
    ],
  },
  {
    id: 10,
    slug: 'survival-game',
    title: '生存游戏',
    author: '朴宰范',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20cover%2C%20group%20of%20survivors%20in%20post-apocalyptic%20world%2C%20intense%20action%20scene%2C%20dark%20and%20gritty%20atmosphere%2C%20dramatic%20lighting%2C%20clean%20digital%20illustration&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '一场神秘实验让整个城市陷入混乱。一群幸存者必须在这个残酷的生存游戏中相互扶持，找出幕后黑手的真相。',
    categories: ['action', 'thriller'],
    rating: 9.4,
    views: 1450000,
    status: '连载中',
    lastUpdated: '2026-08-01',
    featured: true,
    hot: true,
    chapters: [
      { id: 1, title: '第1话 开端', updateDate: '2026-01-01' },
      { id: 2, title: '第2话 混乱', updateDate: '2026-01-08' },
      { id: 3, title: '第3话 集结', updateDate: '2026-01-15' },
      { id: 4, title: '第4话 第一次任务', updateDate: '2026-01-22' },
      { id: 5, title: '第5话 背叛', updateDate: '2026-01-29' },
      { id: 6, title: '第6话 牺牲', updateDate: '2026-02-05' },
      { id: 7, title: '第7话 新的盟友', updateDate: '2026-02-12' },
      { id: 8, title: '第8话 幕后组织', updateDate: '2026-02-19' },
      { id: 9, title: '第9话 决战', updateDate: '2026-02-26' },
    ],
  },
  {
    id: 11,
    slug: 'spring-letter',
    title: '春日来信',
    author: '金多美',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20cover%2C%20girl%20reading%20letter%20under%20cherry%20blossom%20tree%2C%20warm%20spring%20atmosphere%2C%20gentle%20pastel%20colors%2C%20peaceful%20and%20nostalgic%20mood%2C%20clean%20illustration&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '一封来自十年前的信，让女主角踏上了寻找青春回忆的旅程。在这个春天，她将重新遇见那些曾经错过的人和事。',
    categories: ['daily', 'drama', 'romance'],
    rating: 9.1,
    views: 560000,
    status: '已完结',
    lastUpdated: '2026-06-30',
    featured: false,
    hot: false,
    chapters: [
      { id: 1, title: '第1话 旧信', updateDate: '2025-09-01' },
      { id: 2, title: '第2话 回忆', updateDate: '2025-09-08' },
      { id: 3, title: '第3话 母校', updateDate: '2025-09-15' },
      { id: 4, title: '第4话 旧友', updateDate: '2025-09-22' },
      { id: 5, title: '第5话 那个夏天', updateDate: '2025-09-29' },
      { id: 6, title: '第6话 重逢', updateDate: '2025-10-06' },
      { id: 7, title: '第7话 未说出口的话', updateDate: '2025-10-13' },
      { id: 8, title: '第8话 春日终章', updateDate: '2025-10-20' },
    ],
  },
  {
    id: 12,
    slug: 'warrior-queen',
    title: '女王之剑',
    author: '李善美',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20historical%20fantasy%20manhwa%20cover%2C%20female%20warrior%20queen%20in%20armor%2C%20epic%20battlefield%20background%2C%20strong%20and%20dignified%20presence%2C%20dramatic%20composition%2C%20clean%20digital%20art&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '父王驾崩后，年轻的公主被迫披上战甲继承王位。在这片战火纷飞的大陆上，她将用剑与智慧守护自己的王国。',
    categories: ['historical', 'action', 'fantasy'],
    rating: 9.5,
    views: 1680000,
    status: '连载中',
    lastUpdated: '2026-08-05',
    featured: true,
    hot: true,
    chapters: [
      { id: 1, title: '第1话 加冕', updateDate: '2025-12-01' },
      { id: 2, title: '第2话 敌军压境', updateDate: '2025-12-08' },
      { id: 3, title: '第3话 出征', updateDate: '2025-12-15' },
      { id: 4, title: '第4话 第一战', updateDate: '2025-12-22' },
      { id: 5, title: '第5话 俘虏', updateDate: '2025-12-29' },
      { id: 6, title: '第6话 敌将', updateDate: '2026-01-05' },
      { id: 7, title: '第7话 谈判', updateDate: '2026-01-12' },
      { id: 8, title: '第8话 联盟', updateDate: '2026-01-19' },
      { id: 9, title: '第9话 围城', updateDate: '2026-01-26' },
      { id: 10, title: '第10话 女王的抉择', updateDate: '2026-02-02' },
    ],
  },
];